import {Box, styled} from "@mui/material";

import {Colors, Container, IconPerson} from "@bounce/shared/ui";

const Dot = styled("span")<{delay: number}>(({delay}) => ({
  width: "5px",
  height: "5px",
  borderRadius: "50%",
  backgroundColor: Colors.primary._700,
  display: "inline-block",
  animation: "typingBounce 1.4s infinite ease-in-out",
  animationDelay: `${delay}s`,
  "@keyframes typingBounce": {
    "0%, 80%, 100%": {
      transform: "scale(0.6)",
      opacity: 0.4,
    },
    "40%": {
      transform: "scale(1)",
      opacity: 1,
    },
  },
}));

export const TypingIndicator = () => {
  return (
    <Box sx={{mb: "12px", gap: 0, alignItems: "stretch"}}>
      <Container row sx={{gap: 0, alignItems: "flex-end"}}>
        <Container
          sx={{
            width: "24px",
            height: "24px",
            mr: "8px",
            borderRadius: "50%",
            overflow: "hidden",
            flex: "0 0 auto",
            backgroundColor: Colors.primary._100,
            gap: 0,
            justifyContent: "center",
          }}
        >
          <IconPerson style={{width: 20, height: 20, color: Colors.primary._700}} />
        </Container>
        <Container
          sx={{
            py: "8px",
            px: "12px",
            backgroundColor: Colors.primary._100,
            borderRadius: "8px",
            mr: "auto",
            gap: 0,
            alignItems: "center",
            justifyContent: "center",
            minHeight: "36px",
          }}
          aria-label="Typing"
        >
          <Box sx={{display: "flex", gap: "5px", alignItems: "center", height: "20px"}}>
            <Dot delay={0} />
            <Dot delay={0.2} />
            <Dot delay={0.4} />
          </Box>
        </Container>
      </Container>
    </Box>
  );
};
